module.exports = __webpack_public_path__ + "img/4601.a05660ad.png";